import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class HusqvarnaAvailability extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateHusqvarnaAvailability);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateHusqvarnaAvailability);
  }

  /**
   * Updates the availability.
   * Remember to add .js file to scripts.liquid
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateHusqvarnaAvailability = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newHusqvarnaAvailability = event.detail.data.html.querySelector('husqvarna-availability');

    if (!newHusqvarnaAvailability) return;

    morph(this, newHusqvarnaAvailability, { childrenOnly: true });
  };
}

if (!customElements.get('husqvarna-availability')) {
  customElements.define('husqvarna-availability', HusqvarnaAvailability);
}
